import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const LotIdStatus = () => {
  const [lotRecords, setLotRecords] = useState([]);
  const [formData, setFormData] = useState({ lotId: "", description: "", link: "" });
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchLotUploadData = async () => {
    try {
      const res = await axiosInstance.get("/api/get-lotUploadOrNot");
      setLotRecords(res.data);
    } catch (err) {
      console.error("Error fetching lot upload data:", err);
    }
  };

  useEffect(() => {
    fetchLotUploadData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/api/insert-lotUploadOrNot", formData);
      showAlert("✅ Lot upload record added.", "success");
      setShowModal(false);
      setFormData({ lotId: "", description: "", link: "" });
      fetchLotUploadData();
    } catch (err) {
      console.error("Error inserting lot upload record:", err);
      showAlert("❌ Failed to add lot upload record.", "danger");
    }
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };

  const columns = [
    { name: "LOT ID", selector: (row) => row["LOT ID"], sortable: true },
    { name: "Description", selector: (row) => row.DESCRIPTION, sortable: true },
    { name: "Link", selector: (row) => (
      <a href={row.LINK} target="_blank" rel="noopener noreferrer">View</a>
    )},
    {
    name: "Status",
    width: "100px",
    selector: (row) => row["UPLOAD STATUS"] || "N/A",
    sortable: true,
    cell: (row) => {
        const status = row["UPLOAD STATUS"] || "N/A";
        let bgColor = "transparent";
        let textColor = "black";
        let textbold = "normal";       // ← initialize here

        if (status === "Uploaded") {
        bgColor = "green";
        textColor = "white";
        textbold = "bold";  
        } else if (status === "Pending") {
        bgColor = "#fff3cd";
        textColor = "#856404";
        textbold = "bold";          // now this will work
        }

        return (
        <span
            style={{
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: "4px",
            display: "inline-block",
            padding: "2px 2px",
            minWidth: "60px",
            textAlign: "center",
            fontWeight: textbold,    // uses the declared variable
            }}
        >
            {status}
        </span>
        );
    },
    },
    { name: "Uploaded Date", selector: (row) => row.DATE, sortable: true }

  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div id="alertPlaceholder"></div>
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-outline-primary" onClick={() => setShowModal(true)}>
              Add Lot Upload
            </button>
          </div>
          <DataTable columns={columns} data={lotRecords} pagination />
        </main>
      </div>

      {showModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Lot Upload</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <form onSubmit={handleFormSubmit}>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">LOT ID</label>
                      <input type="text" name="lotId" className="form-control" value={formData.lotId} onChange={handleInputChange} required />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Description</label>
                      <input type="text" name="description" className="form-control" value={formData.description} onChange={handleInputChange} required />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Link</label>
                      <input type="url" name="link" className="form-control" value={formData.link} onChange={handleInputChange} required />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">Submit</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LotIdStatus;
